/* eslint-disable @typescript-eslint/no-explicit-any */

import React from "react";
import { useSelector } from "react-redux";

import { format } from "@gamedev-web/gamedev-sdk-core";

import { compareAaaApplicationStepStatus } from "../../helpers/aaaStatusHelpers";
import { useStrings } from "../../localization/localizationHelpers";
import { AaaApplicationStep } from "../../models/status";
import { getAaaApplicationStep, getCurrentGameConcept } from "../../redux/selectors";
import { getOnboardingUser } from "../../redux/selectors/authSelectors";
import { convertDateToString } from "../../server/crm/api/mappers/utils/dateUtils";
import { ContentBoxIcon } from "../ContentBox";
import { InfoBoxBase } from "../InfoBoxBase";

const InfoBoxUnderReview = () => {
  const [
    gameInformationTitle,
    infoBoxAaaSubmittedDate,
    infoBoxAaaUnderReview,
    infoBoxAaaRegisteredEmail,
  ] = useStrings(
    "gameInformationTitle",
    "infoBoxAaaSubmittedDate",
    "infoBoxAaaUnderReview",
    "infoBoxAaaRegisteredEmail"
  );
  const userInfo = useSelector(getOnboardingUser);
  const submitDate = useSelector(getCurrentGameConcept)?.submittedDate;
  const rightSideText =
    submitDate && format(infoBoxAaaSubmittedDate, convertDateToString(submitDate));
  const mainText = format(
    infoBoxAaaUnderReview,
    userInfo?.emailAddress ?? infoBoxAaaRegisteredEmail
  );
  return (
    <InfoBoxBase
      title={gameInformationTitle}
      icon={ContentBoxIcon.Timer}
      rightSideText={rightSideText}
      mainText={mainText}
    />
  );
};

const InfoBoxCompleted = () => {
  const [gameInformationTitle, infoBoxAaaSubmittedDate, infoBoxAaaCompleted] = useStrings(
    "gameInformationTitle",
    "infoBoxAaaSubmittedDate",
    "infoBoxAaaCompleted"
  );
  const submitDate = useSelector(getCurrentGameConcept)?.submittedDate;
  const rightSideText =
    submitDate && format(infoBoxAaaSubmittedDate, convertDateToString(submitDate));
  return (
    <InfoBoxBase
      title={gameInformationTitle}
      icon={ContentBoxIcon.CheckMark}
      rightSideText={rightSideText}
      mainText={infoBoxAaaCompleted}
    />
  );
};

export const InfoBoxAaaGameSubmission = () => {
  const step = useSelector(getAaaApplicationStep);
  const compare = compareAaaApplicationStepStatus;

  if (compare(step, AaaApplicationStep.ApplicationIsBeingReviewed) === 0) {
    return <InfoBoxUnderReview />;
  }

  if (compare(step, AaaApplicationStep.ApplicationComplete) === 0) {
    return <InfoBoxCompleted />;
  }

  return null;
};
